<template>
  <div class="tvshow">
    <app-loader v-if="loading" />

    <div
      v-else
      class="tvshow_details"
    >
      <!-- <section class="tvshow__top"> -->
      <section
        class="tvshow__top"
        :style="{backgroundImage: getImgSrc}"
      >
        <!-- <div
          class="tvshow__top-background"
          :style="{backgroundImage: getImgSrc}"
        /> -->
        <v-container class="pt-2 pb-0 px-2 mb-0">
          <v-layout row>
            <v-breadcrumbs>
              <template v-slot:divider>
                <v-icon dark>
                  arrow_right
                </v-icon>
              </template>
              <v-breadcrumbs-item
                to="/"
                exact
                class="breadcrumbs"
              >
                Startseite
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                to="/serien"
                exact
                class="breadcrumbs"
              >
                Serien
              </v-breadcrumbs-item>
              <v-breadcrumbs-item disabled>
                {{ name }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
            <v-spacer />
            <v-btn
              small
              flat
              class="movie__back-btn white--text caption"
              @click="$router.go(-1)"
            >
              <v-icon
                left
                dark
                class="ma-0"
              >
                arrow_left
              </v-icon>Zurück
            </v-btn>
          </v-layout>
        </v-container>
        <v-container class="py-0">
          <div class="tvshow__top-wrapper">
            <div
              v-if="!isMobile"
              class="tvshow__picture"
            >
              <v-img
                class="tvshow__img elevation-7"
                :src="posterPath ? `${medImgPrefix}${posterPath}` : noPosterSrc "
                :lazy-src="gradient"
                :fade-transition="true"
              >
                <v-layout
                  slot="placeholder"
                  fill-height
                  align-center
                  justify-center
                  ma-0
                >
                  <v-progress-circular
                    indeterminate
                    :width="3"
                    color="red"
                  />
                </v-layout>
              </v-img>
            </div>
            <div class="tvshow__top-content">
              <div class="tvshow__name">
                {{ name }} ({{ firstAirDate | getYear }})
              </div>
              <div class="tvshow__genres">
                <v-btn
                  v-for="(genre, gId) in genres"
                  :key="gId"
                  small
                  flat
                  class="white--text"
                  @click="onGenreClick(genre)"
                >
                  {{ genre.name }}
                </v-btn>
              </div>
              <div class="tvshow__actions">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-progress-circular
                      :rotate="-90"
                      :size="40"
                      :value="voteAverage * 10"
                      :color="getRateColor"
                      class="mx-2"
                      v-on="on"
                    >
                      <span class="caption">{{ voteAverage * 10 }}%</span>
                    </v-progress-circular>
                  </template>
                  <span>Gefällt {{ voteAverage * 10 }}% der Nutzer</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <v-btn
                    v-if="!isFavor"
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="addToFavor"
                  >
                    <v-icon>bookmark</v-icon>
                  </v-btn>
                  <v-btn
                    v-else
                    slot="activator"
                    fab
                    small
                    class="mx-2"
                    :disabled="!checklogin"
                    color="blue-grey darken-1"
                    @click="deleteFromFavor(getFavList.findIndex(el => el.id === id))"
                  >
                    <v-icon color="amber accent-4">
                      bookmark
                    </v-icon>
                  </v-btn>

                  <span v-if="checklogin && !isFavor">Zu meinen Favoriten hinzufügen</span>
                  <span v-else-if="checklogin && isFavor">Aussa mid dem Zeig aus meine Favoriten</span>
                  <span v-else>Meld di erst moi o!</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <app-trailer-modal
                    slot="activator"
                    :video-id="trailer ? trailer.key : ''"
                  />
                  <span v-if="trailer">{{ trailer.name }}</span>
                  <span v-else>Do gibts no nix</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <app-carousel
                    slot="activator"
                    :images="tvShowImages"
                  />
                  <span v-if="tvShowImages.length !== 0">Weitere Bilder aus der Serie</span>
                  <span v-else>Gibd no koa buidl</span>
                </v-tooltip>
              </div>

              <div class="tvshow__items">
                <p
                  v-if="numberOfSeasons"
                  class="my-1"
                >
                  {{ numberOfSeasons }} Staffeln - {{ numberOfEpisodes }} Folgen
                </p>
                <h3 class="tvshow__items-title">
                  Handlung:
                </h3>
                <p class="tvshow__items-overview">
                  {{ overview }}
                </p>
              </div>

              <!-- <ul class="tvshow__items">
                <li class="tvshow__item">
                  <span v-if="firstAirDate">Erste Ausstrahlung: {{ firstAirDate | parseDate }}</span>
                  <span v-else>Erste Ausstrahlung: (keine Daten vorhanden)</span>
                </li>
                <li class="tvshow__item">
                  <span>Hauptproduzent(en): </span>
                  {{ createdBy ? createdBy : 'Hm. Nix zum finden...' }}
                </li>
                <li class="tvshow__item">
                  <span>Anzahl der Staffeln: </span>
                  {{ numberOfSeasons ? numberOfSeasons : 'Nix zum finden...' }}
                </li>
                <li class="tvshow__item">
                  <span>Anzahl Folgen Gesamt: </span>
                  {{ numberOfEpisodes ? numberOfEpisodes : 'Nix zum finden...' }}
                </li>
                <li class="tvshow__item">
                  <span>Dauer der einzelnen Folgen: </span>
                  {{ episodeRunTime ? episodeRunTime[0] + ' Min.': 'Nix zum finden...' }}
                </li>
                <li class="tvshow_">
                  <span>Weitere Folgen geplant? </span>
                  {{ inPoduction ? 'Jep!' : 'Nö...' }}
                </li>
              </ul> -->
            </div>
          </div>
        </v-container>
      </section>

      <section class="tvshow__bottom">
        <v-container>
          <div class="tvshow__seasons mb-4">
            <h3 class="tvshow__seasons-title">
              Staffeln:
            </h3>
            <v-layout
              row
              wrap
              align-end
              fill-height
            >
              <v-flex
                v-for="season in seasons"
                :key="season.id"
                xs6
                sm3
                lg2
                px-2
                py-2
                class="tvshow__seasons-card"
              >
                <div class="elevation-5">
                  <router-link
                    :to="'/serie/' + id + '/staffel/' + season.season_number"
                    class="tvshow__seasons-link"
                  >
                    <div class="tvshow__seasons-picture">
                      <v-lazy-image
                        class="tvshow__seasons-img"
                        :src="season.poster_path ? `${imgPrefix}${season.poster_path}` : noPosterSrc"
                        :lazy-src="gradient"
                      />
                    </div>
                    <div class="tvshow__seasons-name">
                      <h3 class="body-2 main--text text-no-wrap text-truncate ma-0 my-1">
                        {{ season.name }} ({{ season.air_date | getYear }})
                      </h3>
                      <p class="tvshow__seasons-length">
                        {{ season.episode_count }} Folgen
                      </p>
                    </div>
                  </router-link>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <app-person-overview
            v-if="cast.length > 0"
            :credits="cast"
          />
        </v-container>
      </section>
      <section
        v-if="similar.length !== 0"
        class="tvshow__similar"
      >
        <v-container class="pb-0">
          <h3 class="tvshow__similar-title">
            Des kannd a no wos für di sei:
          </h3>
        </v-container>

        <app-tv-card :items="similar" />
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import _ from 'lodash';

import { base } from '../../config/config';
import TrailerModal from '../../components/TrailerModal.vue';
import Carousel from '../../components/Carousel.vue';
import TVOverviewCard from '../../components/tvShows/TVOverviewCard.vue';
import PersonOverview from '../../components/PersonOverview.vue';

const noBannerSrc = require('../../assets/no-banner.jpg');
const noPosterSrc = require('../../assets/noposter.jpg');
const noAvatarSrc = require('../../assets/avatar.jpg');
const gradient = require('../../assets/gradient.jpg');

export default {
  name: 'TVShow',
  components: {
    appTrailerModal: TrailerModal,
    appCarousel: Carousel,
    appTvCard: TVOverviewCard,
    appPersonOverview: PersonOverview,
  },
  filters: {
    getYear(val) {
      if (val) {
        return val
          .split('-')
          .slice(0, 1)
          .join('');
      }
      return '';
    },
    parseDate(val) {
      return val
        .split('-')
        .reverse()
        .join('.');
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.id = parseInt(to.params.id, 10);
    this.initTVPage();
    this.checkScreenWidth();
    next();
  },
  data() {
    return {
      imgPrefix: base.imgPrefix,
      medImgPrefix: base.medImgPrefix,
      posterPrefix: base.posterPrefix,
      profilePrefix: base.medProfilePrefix,
      noBannerSrc,
      noPosterSrc,
      noAvatarSrc,
      gradient,
      isMobile: false,
      id: parseInt(this.$route.params.id, 10),
      backdropPath: '',
      posterPath: '',
      name: '',
      originCountry: '',
      originalLanguage: '',
      originalName: '',
      overview: '',
      createdBy: [],
      episodeRunTime: [],
      firstAirDate: '',
      genres: [],
      genresString: '',
      homepage: '',
      inPoduction: false,
      lastAirDate: '',
      lastEpisodeToAir: {},
      nextEpisodeToAir: {},
      networks: [],
      numberOfEpisodes: 0,
      numberOfSeasons: 0,
      productionCompanies: [],
      seasons: [],
      status: '',
      type: '',
      voteAverage: 0.0,
      votePercent: 0,
      cast: [],
      crew: [],
      videos: [],
      trailer: {},
      tvShowImages: [],
      similar: { tvShows: [] },
    };
  },
  computed: {
    ...mapState({
      getFavList(state) {
        return state.favors.favors.tvShows;
      },
    }),
    getImgSrc() {
      return this.backdropPath
        ? `linear-gradient(to bottom, rgba(77, 77, 77, 0.5), rgba(77, 77, 77, 0.3)), url("${
          this.posterPrefix
        }${this.backdropPath}")`
        : `linear-gradient(to bottom, rgba(77, 77, 77, 0.5), rgba(77, 77, 77, 0.3)), url("${
          this.noBannerSrc
        }")`;
    },
    isFavor() {
      return this.getFavList.findIndex(el => el.id === this.id) !== -1;
    },
    loading() {
      return this.$store.getters.loading;
    },
    checklogin() {
      return this.$store.getters.login;
    },
    getRateColor() {
      let color;

      if (this.voteAverage === 0 || this.voteAverage === '') color = '#bdbdbd';
      if (this.voteAverage >= 1 && this.voteAverage < 5) color = 'error';
      if (this.voteAverage >= 5 && this.voteAverage < 7) color = 'warning';
      if (this.voteAverage >= 7) color = 'success';

      return color;
    },
    paintRate() {
      let color;

      if (this.voteAverage === 0 || this.voteAverage === '') color = 'tvshow__rating--no';
      if (this.voteAverage >= 1 && this.voteAverage < 5) color = 'tvshow__rating--low';
      if (this.voteAverage >= 5 && this.voteAverage < 7) color = 'tvshow__rating--mid';
      if (this.voteAverage >= 7) color = 'tvshow__rating--high';

      return color;
    },
  },
  created() {
    this.initTVPage();
    this.checkScreenWidth();
  },
  methods: {
    checkScreenWidth() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      }
    },
    addToFavor() {
      // TODO: Favoriten-Typ Serie -> firebase definieren!
      const tvshow = {
        type: 'tvShow',
        id: this.id,
        poster_path: this.posterPath,
        name: this.name,
        first_air_date: this.firstAirDate,
        vote_average: this.voteAverage,
      };

      this.$store.dispatch('addToFavorList', tvshow);
    },
    deleteFromFavor(index) {
      const id = this.getFavList[index].fbId;
      this.$store.dispatch('deleteFromFavorList', { id, title: this.name });
    },
    parseDate(val) {
      return val
        .split('-')
        .reverse()
        .join('.');
    },
    parseYear(date) {
      if (date) {
        return new Date(date).getFullYear();
      }
      return '';
    },
    async getDetails() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}?api_key=${base.key}&${
            base.language
          }`,
        );
        const { data } = res;

        this.backdropPath = data.backdrop_path;
        this.posterPath = data.poster_path;
        this.name = data.name;
        this.originCountry = data.origin_country;
        this.originalLanguage = data.original_language;
        this.originalName = data.original_name;
        this.overview = data.overview;
        this.createdBy = data.created_by;
        this.episodeRunTime = data.episode_run_time;
        this.firstAirDate = data.first_air_date;
        this.genres = data.genres;
        this.homepage = data.homepage;
        this.inPoduction = data.in_production;
        this.lastAirDate = data.last_air_date;
        this.lastEpisodeToAir = data.last_episode_to_air;
        this.nextEpisodeToAir = data.next_episode_to_air;
        this.networks = data.networks;
        this.numberOfEpisodes = data.number_of_episodes;
        this.numberOfSeasons = data.number_of_seasons;
        this.productionCompanies = data.production_companies;
        // drop specials
        this.seasons = _.dropWhile(data.seasons, s => (s.season_number === 0 || s.name === 'Specials'));
        this.status = data.status;
        this.type = data.type;
        this.voteAverage = data.vote_average;
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getFallbackDetails() {
      // TODO: Fallback Details -> locale daten prüfen und bei bedarf ersetzten
      try {
        const res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}?api_key=${base.key}`,
        );
        const { data } = res;
        // console.log("Fetching englisch biography...");

        if (data.overview) {
          this.overview = data.overview;
        } else {
          this.overview = 'Nicht verfügbar im Moment...';
        }

        if (data.seasons) {
          this.seasons = data.seasons;
        } else {
          this.seasons = 'Nicht verfügbar...';
        }
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getCredits() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}/credits?api_key=${base.key}`,
        );
        const { data } = res;

        if (data.cast.length > 0) {
          this.cast = _.orderBy(data.cast, 'order', 'asc');
        }
        if (data.crew.length > 0) {
          this.crew = data.crew;
        }
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getVideos() {
      try {
        let res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}/videos?api_key=${base.key}&${
            base.language
          }`,
        );

        if (res.data.results.length > 0) {
          const { data } = res;
          this.videos = data.results;
        } else {
          res = await axios.get(
            `${base.urlPrefix}/tv/${this.id}/videos?api_key=${base.key}`,
          );
          const { data } = res;
          this.videos = data.results;
        }
      } catch (error) {
        // TODO: Error-Log -> keine Ausgabe von Fehlern
        // this.$store.commit(
        //   'setError',
        //   `Uups! Do is wos schief glaffa: ${error.message}`,
        // );
      }
    },
    async getImages() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}/images?api_key=${base.key}`,
        );
        const { data } = res;
        this.tvShowImages = data.backdrops;
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },
    async getSimilar() {
      try {
        const res = await axios.get(
          `${base.urlPrefix}/tv/${this.id}/similar?api_key=${base.key}&${
            base.language
          }&page=1`,
        );
        const { data } = res;
        this.similar.tvShows = data.results;
        // console.log('similar:', this.similar);
      } catch (error) {
        this.$store.commit(
          'setError',
          `Uups! Do is wos schief glaffa: ${error.message}`,
        );
      }
    },

    async initTVPage() {
      this.$store.commit('clearError');
      this.$store.commit('setLoading', true);

      await this.getDetails();
      if (!this.overview) {
        await this.getFallbackDetails();
      }
      await this.getCredits();
      await this.getVideos();
      await this.getImages();
      await this.getSimilar();

      this.parceCreator();
      this.parceGenres();
      this.parceTrailer();

      this.$store.commit('setLoading', false);
    },
    parceGenres() {
      if (this.genres.length > 0) {
        const genres = this.genres.map(el => el.name);

        this.genresString = genres.join(', ');
      } else {
        this.genresString = '';
      }
    },
    parceTrailer() {
      // console.log('videos:', this.videos);

      if (this.videos.length !== 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.videos.length; i++) {
          const video = this.videos[i];
          if (video.type === 'Trailer') {
            this.trailer = video;
            break;
          }
        }
      } else {
        this.trailer = '';
      }

      // console.log('parcedTrailer:', this.trailer);
    },
    parceCreator() {
      if (this.createdBy.length > 0) {
        const creators = this.createdBy.map(el => el.name);
        this.createdBy = creators.join(', ');
      } else {
        this.createdBy = '';
      }
    },
    async setVotes(timeout) {
      await setTimeout(() => {
        this.votePercent = this.voteAverage * 10;
      }, timeout);
    },
    onGenreClick(genre) {
      this.$store.commit('setUserMessage', `Suche nach Genre: ${genre.name} bald verfügbar!`);
    },
  },

};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  width: 100%;
  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.tvshow {
  position: relative;
  height: 100%;

  &__top {
    position: relative;
    background-size: cover;
    background-position: center top;
    // height: 500px;

    @media (max-width: 1263px) {
      // height: 400px;
    }

    @media (max-width: 768px) {
      // height: 340px;
    }

    @media (max-width: 600px) {
      // height: 300px;
    }
  }

  &__top-background {
    position: fixed;
    width: 100%;
    top: 20%;
    height: 350px;
    left: 0;
    // filter: blur(1px);
    background-size: cover;
  }

  &__top-wrapper {
    position: relative;
    display: flex;
  }

  &__picture {
    position: relative;
    min-width: 301px;
    max-height: 452px;
    // animation-delay: 0.5s;
    // overflow: hidden;

    @media (max-width: 1263px) {
      min-width: 235px;
      max-height: 352px;
    }

    @media (max-width: 768px) {
      display: none;
    }
  }

  &__img {
    display: block;
    width: 100%;
  }

  &__top-content {
    width: 100%;
    min-height: 450px;
    animation-delay: 0.5s;
  }

  &__name {
    display: flex;
    font-size: 20px;
    margin-left: 30px;
    font-weight: 700;


    @media (max-width: 768px) {
      font-weight: 500;
      font-size: 18px;
      margin-left: 0;
    }

    @media (max-width: 600px) {
      line-height: 18px;
      margin-bottom: 10px;
    }
  }

  &__genres {
    padding: 5px 15px 0px;
    display: flex;

    @media (max-width: 768px) {
      padding: 5px 0 0;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    padding-left: 30px;
    margin-top: 5px;
    border-top: 1px solid #546e7a;
    background-color: rgba(0, 0, 0, 0.6);

    @media (max-width: 768px) {
      margin-top: 10px;
      padding: 0 20px;
    }

    @media (max-width: 425px) {
      display: flex;
      justify-content: space-between;
    }
  }

  &__rating {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    min-height: 40px;
    text-align: center;
    border-radius: 50%;
    margin-right: 10px;
    cursor: default;
    box-shadow: 0 3px 10px 2px rgba(0, 0, 0, 0.1);
    color: #fff;

    &--no {
      background-color: #bdbdbd;
    }

    &--low {
      background-color: #d84315;
    }

    &--mid {
      background-color: #ffa726;
    }

    &--high {
      background-color: #43a047;
    }

    @media (max-width: 600px) {
      margin-left: 10px;
    }
  }

  &__items {
    padding: 10px 30px;
    margin-top: 10px;
    list-style: none;
    font-size: 1em;
    font-weight: 380;
    // padding-left: 30px;
    border-top: 1px solid #546e7a;
    background-color: rgba(0, 0, 0, 0.6);
    text-align: justify;

    @media (max-width: 960px) {
      // padding: 10px 0 10px 30px;
      font-size: 14px;
    }

    @media (max-width: 768px) {
      padding: 10px 20px;
      font-size: 14px;
    }

    @media (max-width: 600px) {
      margin-top: 15px;
      font-size: 13px;
    }

    span {
      font-weight: 400;
    }
  }
  &__items-title {
    font-weight: 400;
    font-size: 20px;
    margin-bottom: 10px;
    border-bottom: 1px solid #546e7a;
  }

  &__item {
    font-weight: 300;
    margin-bottom: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    @media (max-width: 960px) {
      margin-bottom: 5px;
    }

    @media (max-width: 600px) {
      padding-left: 10px;
      margin-bottom: 4px;
    }
  }

  &__bottom {
    animation-delay: 0.5s;
  }

  &__bottom-content {
    display: flex;

    @media (max-width: 1263px) {
      flex-direction: column;
    }
  }

  &__images {
    display: flex;
    align-items: flex-end;
  }

  &__seasons-title,
  &__overview-title,
  &__similar-title {
    width: 100%;
    font-weight: 300;
    margin-bottom: 15px;
    font-size: 20px;
    border-bottom: 1px solid #546e7a;

    @media (max-width: 768px) {
      font-size: 18px;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__seasons {
    // margin-bottom: 20px;
  }

  &__seasons-card {
    transition: transform 0.25s ease-in-out;

    &:hover {
      @media (min-width: 959px) {
        transform: translateY(-5px);
      }
    }

    // @media screen and (min-width: 600px) and (max-width: 959px){
    //   padding: 10px 15px !important;
    // }
  }

  &__seasons-picture {
    // max-height: 250px;
  }

  &__seasons-img {
    max-height: 250px;
    border-radius: 3px 3px 0 0;
  }

  &__seasons-name {
    padding: 5px;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.8);
    color: #303030;
    border-radius: 0 0 3px 3px;
  }

  &__seasons-length {
    margin-bottom: 0;
    font-weight: 300;
  }

  &__overview-text {
    font-size: 14px;
    font-weight: 300;
    text-align: justify;

    @media (max-width: 600px) {
      font-size: 13px;
    }
  }

  &__seasons-link {
    text-decoration: none;
  }
}

</style>
